import Vue from 'vue';
import VueRouter from 'vue-router';
import {Auth} from "@aws-amplify/auth";

import {fn_appUserSession, lcl_userInfo as userInfo} from "@/utils/init.js";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
});
const routes = [
  {
    path: '/login',
    name: 'LogIn',
    component: () => import("@/views/LogIn.vue"),
    beforeEnter(to, from, next) {
      Auth.currentSession().then(sess => {
        next({name: 'KBDP'});
      }).catch(err => {
        next();
      });
    }
  },
  {
    path: '/logout',
    name: 'LogOut',
    beforeEnter(to, from, next) {
      let ui = userInfo.getUserInfo();
      if (ui) {
        fn_appUserSession(ui.event_id, true).then(resp => {
          userInfo.removeUserInfo(); //Must do after logout
          Auth.signOut().then(x => next({
            name: 'LogIn',
            params: {logout: true}
          }));
        });
      }
      else {
        userInfo.removeUserInfo();
        Auth.signOut().then(x => next({
          name: 'LogIn',
          params: {logout: true}
        }));
      }
    }
  },
  {
    path: '/',
    redirect: {path: '/kbdp'},
  },
  {
    path: '/kbdp',
    alias: ['/kbdp/#*', '/kbdp#*'],
    name: 'KBDP',
    // props: true,
    component: () => import("@/views/KBDP.vue"),
    beforeEnter(to, from, next) {
      //For Page Loads/Reloads, after being authenticated
      fn_authRoutine(to, from, next);
    },
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import("@/views/Error.vue"),
    props: true,
  },
  {
    path: '/*',
    redirect: {
      name: 'Error',
      params: {p_message: 'Invalid Request'}
    },
  }
];
router.addRoutes(routes);


//For SPA/Async Requests
function fn_beforeEach(to, from, next) {
  //console.log('from ' + from.name, '---> to ' + to.name);
  //console.log('from ' + from.hash, '---> to ' + to.hash);

  if (to.name == 'KBDP' && from.name != null) {
    Auth.currentSession().then(() => {
      let kbdp = (document.getElementById('KBDP') || {}).__vue__;
      if (kbdp) kbdp.m_chkUnsv(next); //Check Unsaved Changes
      else next();

    }).catch(() => {
      window.sessionStorage.setItem('sessionExp', true);
      next({name: 'LogOut'});
    });
  }
  else next();
}

//For Page Loads/Reloads
/*
function fn_authRoutine(to, from, next) {
  Auth.currentSession().then(sess => {
    import("@/utils/ref-data.js").then(module => {
      module.fn_loadRTU().then(resp => {
        next(); //Correct place to do next()
      });
    });
  }).catch(err => {
    userInfo.removeUserInfo();
    if (Auth.userPool) {
      next({name: 'LogIn'});
    }
  });
}
*/

async function fn_authRoutine(to, from, next) {
  try {
    await Auth.currentAuthenticatedUser();

    const module = await import("@/utils/ref-data.js");
    await module.fn_loadRTU();

    next();
  } catch (err) {
    userInfo.removeUserInfo();
    next({ name: 'LogIn' });
  }
}


function fn_authConfig(config) {
	console.log('In fn_authConfig');
	console.log(config);
  Auth.configure(config);
  router.beforeEach((to, from, next) => {
    fn_beforeEach(to, from, next);
  });
}

export {router, fn_authConfig};
